var React = require('react');

function ShowInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8.2704 24.2114L8.27041 24.2114C11.611 18.7041 17.8573 15 25 15C32.1398 15 38.3874 18.7015 41.7296 24.2114L42.5846 23.6927L41.7296 24.2114C41.9075 24.5046 42 24.8364 42 25.1724C42 25.5085 41.9075 25.8402 41.7296 26.1334L42.5846 26.6521L41.7296 26.1335C38.389 31.6408 32.1427 35.3448 25 35.3448C17.8602 35.3448 11.6126 31.6434 8.2704 26.1335L7.41642 26.6515L8.2704 26.1335C8.09252 25.8403 8 25.5085 8 25.1724C8 24.8364 8.09252 24.5046 8.2704 24.2114Z","stroke":"#2B2B2B","strokeWidth":"2","key":0}),React.createElement("ellipse",{"cx":"24.9996","cy":"25.1723","rx":"6.54545","ry":"6.38424","fill":"currentColor","key":1})]);
}

ShowInline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = ShowInline;

ShowInline.default = ShowInline;
